import { t } from '@lingui/macro';

const formatLocation = (city?: string | null, state?: string | null) =>
  [city, state].filter(Boolean).join(', ');

export const buildDepotOptions = (
  depotsData: ManagedDepotsQuery | undefined,
) => {
  const depots = depotsData?.managedAssetGroupings?.collection || [];
  return depots.map((depot) => {
    const location = formatLocation(depot.city, depot.state);
    const accountName = depot.platformAccount?.name;
    const details = [accountName && t`Account: ${accountName}`, location]
      .filter(Boolean)
      .join(' – ');

    return {
      id: depot.id,
      label: depot.name,
      value: depot.id,
      labelDetails: details || undefined,
    };
  });
};
